/**
 * 削除確認ダイアログの状態管理（Phaser非依存のロジック層）
 *
 * AICharacterEditScene 等から利用し、
 * UI描画は呼び出し側のシーンが担当する。
 */

export const DELETE_CONFIRM_MESSAGES = {
  title: '削除確認',
  body: 'このAIキャラを削除しますか？',
  yes: 'はい',
  no: 'いいえ',
} as const;

export interface DeleteConfirmState {
  isOpen: boolean;
  targetId: string | null;
  onConfirm: ((id: string) => void) | null;
  onClose: (() => void) | null;
}

export function createDeleteConfirmState(): DeleteConfirmState {
  return {
    isOpen: false,
    targetId: null,
    onConfirm: null,
    onClose: null,
  };
}

/**
 * 「はい」を選択した場合の処理
 * onConfirm → onClose の順で実行し、状態をリセットする
 */
export function handleConfirm(state: DeleteConfirmState): void {
  if (!state.isOpen || !state.targetId) return;

  const id = state.targetId;
  const confirm = state.onConfirm;
  const close = state.onClose;

  // 状態を先にリセットして二重実行を防止
  state.isOpen = false;
  state.targetId = null;
  state.onConfirm = null;
  state.onClose = null;

  confirm?.(id);
  close?.();
}

/**
 * 「いいえ」を選択した場合の処理
 * onClose のみ実行し、状態をリセットする
 */
export function handleCancel(state: DeleteConfirmState): void {
  if (!state.isOpen) return;

  const close = state.onClose;

  state.isOpen = false;
  state.targetId = null;
  state.onConfirm = null;
  state.onClose = null;

  close?.();
}
